export const GET_CONTRIBUTIONS = "GET_CONTRIBUTIONS";
export const CONTRIBUTION_ERROR = "CONTRIBUTION_ERROR";
export const SET_PRIMARY_COLOR = "SET_PRIMARY_COLOR";
export const TOOGLE_MOOD = "TOOGLE_MOOD";
export const TOOGLE_CONTACT_MODAL = "TOOGLE_CONTACT_MODAL";
